import { Row } from "@tanstack/react-table";
import { createContext } from "react";
import { ColumnType } from "../components/shared/table/types/tableProps";

export type FiltersTable = {
    filterColumnName?: string,
    filterType?: ColumnType,
    filterColumnValue?: string | number | Date
}

export enum SortType {
    Asc = "rosnąco",
    Desc = "malejąco",
    None = "brak"
}

export type SortConfig = {
    sortType: SortType,
    filterColumnName?: string
}

const defaultFilterTables = () => {
    var filterTables: FiltersTable[] = [{filterColumnName: "", filterColumnValue: "", filterType: ColumnType.Text}]
    return filterTables;
}

export type CheckboxTable = {
    dataRow?: Row<any>;
}

const defaultCheckboxesTable = () => {
    var checkboxesTables: Row<any>[] = []
    return checkboxesTables;
}

export type ReloadTable = {
    reload: boolean;
}

const defaultReloadTable = () => {
    var reloadTable: boolean = false
    return reloadTable;
}

const defaultSortConfig = () => {
    var sortConfig: SortConfig = {sortType: SortType.None, filterColumnName: ""}
    return sortConfig;
}

export const TableContext = createContext({
    checkboxesTable: defaultCheckboxesTable(),
    setCheckboxesTable: (props: Row<any>[]) => {},
    filtersTableDb: defaultFilterTables(),
    setFiltersTableDb: (props: FiltersTable[]) => {},
    filtersTableTaskList: defaultFilterTables(),
    setFiltersTableTaskList: (props: FiltersTable[]) => {},
    reloadTable: defaultReloadTable(),
    setReloadTable: (props: boolean) => {},
    sortConfigDb: defaultSortConfig(),
    setSortConfigDb: (props: SortConfig) => {},
    sortConfigTaskList: defaultSortConfig(),
    setSortConfigTaskList: (props: SortConfig) => {}
});